<template>
    <iframe id="kollusChattroll" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" allowtransparency="true" :src=chattingUrl></iframe>
</template>
<script>
export default {
    name: 'kollus-catting',
    props: {
        chatrollInfo: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            chattingOption: {},
            chattingUrl: '',
        };
    },
    mounted() {
        this.chattingUrl = this.chatrollInfo.chatting.data.embed_src;
    },
};
</script>

<style scoped>
#kollusChattroll {
    height: 100%;
    width: 100%;
}
</style>
